<template lang="pug">
    .card.game-master-card(:class="{ 'game-master-card--sm': small }")

        .card-img-top(v-if="!small" :style="coverImageStyle")

        .card-body

            .card-title
                .row.align-items-center
                    template(v-if="small")
                        .col-6
                            .card-img-top(:style="coverImageStyle")
                        .col-6.clearfix
                            .user-icon(:style="profileImageStyle")
                            .title {{ profile.name }}
                                span {{ location }}
                            .card-review
                                rating-stars(:rating="profile.rating")
                                span.rating.ml-1 {{ profile.rating || '-' }}
                    template(v-else)
                        .col-8.clearfix
                            .user-icon(:style="profileImageStyle")
                            .title {{ profile.name }}
                                span {{ location }}
                        .col-4.text-end
                            span.price ${{ product.rates[0].price }}/hr.

            .card-review(v-if="!small")
                rating-stars(:rating="profile.rating")
                span.rating.ml-1 {{ profile.rating || '-' }}
                span.text {{ profile.review_count }} {{ profile.review_count | pluralize('review') }}

            hr

            p.card-text(ref="aboutText" :class="{ open: readMore }") {{ product.last_review || profile.about }}
                a(v-if="showReadMore" @click="readMore = !readMore")
                    span Read {{ readMore ? 'less' : 'more' }}

            router-link.btn.btn-danger.btn-large.color-white(:to="{ name: 'game-master-profile-page', params: { cityDashState: cityDashStateLocal, nameDashId } }") View Details

</template>

<script>

const MAX_ABOUT_TEXT_LENGTH = 80

export default {
    name: 'game-master-card',

    props: {
        product: {
            type: Object,
            required: true,
        },
        cityDashState: {
            type: String,
            default: null,
        },
        small: {
            type: Boolean,
            default: false,
        },
    },

    data() { return {
        showReadMore: false,
        readMore: false,
    }},

    computed: {
        profile() {
            return this.product.user.data
        },
        nameDashId() {
            const slug = _.kebabCase(this.profile.name)
            return `${slug}-${this.profile.id}`
        },
        coverImageStyle() {
            return this.profile.cover_image_md ?
                { 'background-image': `url(${this.baseUri}${this.profile.cover_image_md})` } :
                {}
        },
        profileImage() {
            return this.profile.profile_image_sm || '/images/client/lairdnd/default-profile-image.png'
        },
        profileImageStyle() {
            return { 'background-image': `url(${this.baseUri}${this.profileImage})` }
        },
        games() {
            return this.product.games
        },
        city() {
            return this.product.location.city
        },
        location() {
            return `${this.product.location.city} ${this.product.location.state}`
        },
        bookable() {
            return !this.profile.owner
        },
        reviewable() {
            return !this.profile.owner
        },
        showBookingForm() {
            return !this.booking && !this.order
        },
        showPaymentForm() {
            return !!this.booking && !this.order
        },
        showThankYou() {
            return !!this.order
        },
        cityDashStateLocal() {
            return this.cityDashState || _.kebabCase(this.product.location.formatted_address)
        },
    },

    mounted() {
        window.addEventListener('resize', this.resize)
        this.resize()
    },

    unmounted() {
        window.removeEventListener('resize', this.resize)
    },

    methods: {
        resize() {
            const aboutTextEl = this.$refs.aboutText
            if (!this.readMore) {
                this.showReadMore = aboutTextEl.scrollHeight > aboutTextEl.clientHeight
            }
        },
    }
}
</script>
